var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1C8555ED-3199-49E0-A71D-0D1C63CD1F58") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-279.000000, -662.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "translate(279.000000, 662.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Title",
    stroke: "none",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 5,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 47,
    y: 5,
    fill: "#000000"
  }, "Title")), /*#__PURE__*/React.createElement("text", {
    id: "Title-Copy-10",
    stroke: "none",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 5,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2,
    y: 5,
    fill: "#000000"
  }, "Title")), /*#__PURE__*/React.createElement("text", {
    id: "Title-Copy-3",
    stroke: "none",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 5,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 81,
    y: 5,
    fill: "#000000"
  }, "Title")), /*#__PURE__*/React.createElement("text", {
    id: "Lorem-ipsum",
    stroke: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 4.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2,
    y: 17,
    fill: "#6F6F6F"
  }, "Lorem ipsum")), /*#__PURE__*/React.createElement("text", {
    id: "Dolar-sit",
    stroke: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 4.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 47,
    y: 17,
    fill: "#6F6F6F"
  }, "Dolar sit")), /*#__PURE__*/React.createElement("text", {
    id: "Amet",
    stroke: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 4.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 81,
    y: 17,
    fill: "#6F6F6F"
  }, "Amet")), /*#__PURE__*/React.createElement("text", {
    id: "Amet-Copy",
    stroke: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 4.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 81,
    y: 32,
    fill: "#6F6F6F"
  }, "Amet")), /*#__PURE__*/React.createElement("text", {
    id: "Amet-Copy-2",
    stroke: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 4.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 81,
    y: 47,
    fill: "#6F6F6F"
  }, "Amet")), /*#__PURE__*/React.createElement("text", {
    id: "Lorem-ipsum-Copy",
    stroke: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 4.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2,
    y: 32,
    fill: "#6F6F6F"
  }, "Lorem ipsum")), /*#__PURE__*/React.createElement("text", {
    id: "Dolar-sit",
    stroke: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 4.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 47,
    y: 32,
    fill: "#6F6F6F"
  }, "Dolar sit")), /*#__PURE__*/React.createElement("text", {
    id: "Lorem-ipsum-Copy-2",
    stroke: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 4.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2,
    y: 47,
    fill: "#6F6F6F"
  }, "Lorem ipsum")), /*#__PURE__*/React.createElement("text", {
    id: "Dolar-sit",
    stroke: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 4.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 47,
    y: 47,
    fill: "#6F6F6F"
  }, "Dolar sit")), /*#__PURE__*/React.createElement("line", {
    x1: 0.474576271,
    y1: 22.5,
    x2: 111.525424,
    y2: 22.5,
    id: "Line-4",
    stroke: "#BBBBBD",
    strokeWidth: 0.3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.474576271,
    y1: 37.5,
    x2: 111.525424,
    y2: 37.5,
    id: "Line-4-Copy-4",
    stroke: "#BBBBBD",
    strokeWidth: 0.3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.474576271,
    y1: 52.5,
    x2: 111.525424,
    y2: 52.5,
    id: "Line-4-Copy-5",
    stroke: "#BBBBBD",
    strokeWidth: 0.3,
    strokeLinecap: "square"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/Table.69615ae412180c14e3b02652707bd02f.svg";
export { ForwardRef as ReactComponent };